"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteHPEntry = deleteHPEntry;
exports.getFirstTimeAccessApi = getFirstTimeAccessApi;
exports.getHPCustomizeConfig = getHPCustomizeConfig;
exports.getHPOnboardingData = getHPOnboardingData;
exports.getHPViewAllData = getHPViewAllData;
exports.getHealthFeed = getHealthFeed;
exports.getHistoricalSyncTimestamp = getHistoricalSyncTimestamp;
exports.getHpSummary = getHpSummary;
exports.getOnboardingSync = getOnboardingSync;
exports.getPatientHPOnboardingData = getPatientHPOnboardingData;
exports.postHPCustomizeConfig = postHPCustomizeConfig;
exports.postHPEntry = postHPEntry;
exports.resetHistoricalSync = resetHistoricalSync;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getHPOnboardingData(tokenData, requestParams = {}) {
  const {
    enableCache
  } = requestParams || {};
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.GET_HEALTH_PROFILE_ONBOARDING_DATA}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    enableCache
  });
}
function postHPEntry(requestParams, tokenData) {
  const {
    onboarding = false,
    ...bodyParams
  } = requestParams || {};
  const queryString = onboarding ? (0, _utils.getQuery)({
    onboarding
  }) : '';
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.POST_HP_ENTRY}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = bodyParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPatientHPOnboardingData(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.GET_PATIENT_ONBOARDING_STATUS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHPCustomizeConfig(requestParams, tokenData) {
  const userId = requestParams === null || requestParams === void 0 ? void 0 : requestParams.userId;
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}${_ApiConst.GET_HP_VIEW_CONFIG}/${userId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function postHPCustomizeConfig(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}update/${_ApiConst.GET_HP_VIEW_CONFIG}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getFirstTimeAccessApi(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}${_ApiConst.GET_FIRST_TIME_ACCESS_ENDPOINT}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function deleteHPEntry(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}${_ApiConst.DELETE_HP_ENTRY}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHPViewAllData(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}${_ApiConst.GET_HP_VIEW_ALL_DATA}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getOnboardingSync(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.GET_ONBOARDING_SYNC}${requestParams}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHealthFeed(requestParams, tokenData) {
  const userId = requestParams === null || requestParams === void 0 ? void 0 : requestParams.userId;
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.GET_HEALTH_PROFILE_FEED}${userId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHistoricalSyncTimestamp(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.GET_HISTORICAL_SYNC_TIMESTAMP}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function resetHistoricalSync(requestParams, tokenData) {
  const queryString = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_V2_CONST}${_ApiConst.RESET_HISTORICAL_SYNC}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getHpSummary(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.HP_URL}${_ApiConst.COMMON_HP_CONST}${_ApiConst.GET_HP_SUMMARY}${requestParams}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}